// import gsap from 'gsap'
// import ScrollTrigger from 'gsap/ScrollTrigger'
// import ScrollToPlugin from 'gsap/ScrollToPlugin'
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export class ClassTab {
  constructor() {
    this.tabElems;
    this.excute();
  }
  excute = () => {
    const _this = this;

    this.tabElems = document.querySelectorAll(".js-tab-lists");
    // const _this = this;
    this.tabElems.forEach((tabElem) => {
      this.offsetY = 0;
      if (tabElem.getAttribute("data-offset-y"))
        this.offsetY = tabElem.getAttribute("data-offset-y");
      const listElems = tabElem.querySelectorAll("li");
      const tabConWrapElem = tabElem.nextElementSibling;
      let tabIndex;
      listElems.forEach((listElem) => {
        const listBtn = listElem.querySelector("button");
        listBtn.addEventListener("click", function (e) {
          e.preventDefault();
          tabIndex = [].slice.call(listElems).indexOf(listElem);

          listElems.forEach((listElem) => {
            listElem.classList.remove("is-active");
          });
          if (!listElem.classList.contains("is-active")) {
            listElem.classList.add("is-active");
          }
          const tabConElems = tabConWrapElem.querySelectorAll(".js-tab-con");
          tabConElems.forEach((tabConElem) => {
            tabConElem.classList.remove("is-active");
          });
          const thisTabConElem = tabConElems[tabIndex];
          thisTabConElem.classList.add("is-active");
          // const offsetH = document.getElementById('js-header-h').getBoundingClientRect().height
          // alert(offsetH)
          gsap.to(window, {
            duration: 1,
            ease: "power4.inOut",
            delay: 0,
            scrollTo: {
              y: tabElem,
              offsetY: _this.offsetY,
              autoKill: false,
            },
            onComplete: () => {
              // smoothLinkClickFlag = false;
            },
          });
          return false;
        });
      });
    });
  };
}
